import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import HeroM from "../components/HeroM";
import Faq from "../components/Faq";
import InBlog from "../components/InBlog";
import Footer from "../components/Footer";
import ChatButton from "../components/ChatButton";
import { Helmet } from "react-helmet-async";

import seoChanProfile from '../SeoChanProfile.png';
import seoChanHi from '../Hi-SeoChan.png';

function AskSeoChan() {
  return (
    <>
      {/* Helmet component to wrap all meta tags and title */}
      <Helmet>
        <title>Ask SeoChan - Your AI SEO Assistant</title>
        <meta
          name="description"
          content="Chat with SeoChan, the AI assistant built by Seotic to guide your SEO strategy. Available inside Seotic and as SeoChan GPT on ChatGPT."
        />
        <meta
          name="keywords"
          content="SeoChan, Seotic assistant, AI SEO assistant, SeoChan GPT"
        />
        <link rel="icon" href="https://www.seotic.co/favicon.ico" />

        {/* Open Graph Meta Tags */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.seotic.co" />
        <meta property="og:title" content="Ask SeoChan - Your AI SEO Assistant" />
        <meta
          property="og:description"
          content="SeoChan helps with SEO questions and Seotic tools. Meet SeoChan Internal or talk through SeoChan GPT in the ChatGPT marketplace."
        />
        <meta property="og:image" content="https://www.seotic.co/og-image.jpg" />

        {/* Twitter Card Meta Tags */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.seotic.co" />
        <meta property="twitter:title" content="Ask SeoChan - Your AI SEO Assistant" />
        <meta
          property="twitter:description"
          content="Get quick SEO answers from SeoChan. Use SeoChan Internal within Seotic or try SeoChan GPT on the ChatGPT market."
        />
        <meta property="twitter:image" content="https://www.seotic.co/og-image.jpg" />
      </Helmet>

      <Navbar />
      
      <section id="ask-seochan" className="">
        <div className="container mx-auto py-20 px-4 lg:px-0 text-lg my-10">
         <div className="container mx-auto space-y-10">
          <div className="flex flex-col justify-center items-center mb-8">
            <h2 className="text-center text-base/7 uppercase text-slate-400">Seochan</h2>
            <p className="mx-auto mt-2 max-w-lg text-center text-4xl font-semibold tracking-tight text-balance text-gray-950 sm:text-5xl">
              Ask about seotic or anything SEO related.
            </p>
          </div>
         </div>
       
         
         <div className="grid md:grid-cols-6 gap-5 grid-cols-1">
                             
                                        
  <p className="p-10 border rounded-lg md:col-span-2">
	  
	     <img
                  src={seoChanHi}
                  alt="SeoChan"
                  className="w-24 border rounded-lg px-2 pt-4  mb-5"
                />

	 
            SeoChan is your friendly AI guide through everything SEO. Built by the Seotic team, she answers questions, explains features and suggests winning strategies so you can rank faster without the guesswork.
           
          </p>

                             
           <div className="border rounded-lg px-10 pt-12 bg-slate-50 md:col-span-4">
	             <p className="mb-5 px-5 md:px-20">
            <span className="font-semibold">SeoChan</span> lives inside the <span className="font-semibold text-yellow-500">Seotic</span> platform. She understands your workspace and gives contextual advice while you audit sites, research keywords or build content.
          </p>

	          <div className="flex flex-col items-center justify-center bg-white text-center text-slate-500 dark:text-slate-400 border border-b-0 pt-10 
	              pb-5 px-5 rounded-t-lg">
                <img
                  src={seoChanProfile}
                  alt="SeoChan"
                  className="w-14 h-14 rounded-lg mb-3 border border-slate-200 dark:border-slate-700 shadow-sm"
                />
                <h2 className="text-lg font-medium text-slate-700">
                  Hello, I’m SeoChan
                </h2>
                <p className="max-w-sm text-sm mt-1">
                  Your SEO assistant inside Seotic. Ask me about rankings, backlinks, content or anything SEO related.
                </p>
			</div>
          </div>
           
 
           
          <p className="p-10 border rounded-lg md:col-span-3 flex">
	

<p>

            Prefer to chat from anywhere? <span className="font-semibold"><a href="https://chatgpt.com/g/g-68b20bfc78a48191b5aca27feb98787c-seochan" title="SeoChan GPT" target="_blank">SeoChan GPT</a></span> is available on the ChatGPT marketplace. Ask her anything about SEO, Seotic , Website audit or digital marketing and get instant, conversational answers.
</p>
          </p>
          <p className="p-10 border rounded-lg md:col-span-3">
            Whether you're troubleshooting a crawl issue or planning a campaign, SeoChan is ready to help. Ask away and let the algorithms work for you.
          </p>
     
        </div>
        </div>
      </section>

      <InBlog />
      <Faq />
      
            <div className="container mx-auto my-10">
        <ChatButton />
      </div>
      <Footer />
    </>
  );
}

export default AskSeoChan;
